(function () {
  if (window.__productSectionRide) return;
  window.__productSectionRide = true;

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ride-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ride-panel]'));
    if (!tabs.length) return;
    root.dataset.bound = 'true';

    function activate(index) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-ride-tab') === String(index);
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-on', panel.getAttribute('data-ride-panel') === String(index));
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-ride-tab'));
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section-ride]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
